<template>
    <v-row align="center">
        <v-col cols="auto" class="headline text-start align-start d-flex align-center" style="gap: 8px">
            <template v-if="showsPrevButton">
                <v-btn small text fab tile @click="$emit('prev')"> <v-icon> mdi-chevron-left </v-icon> </v-btn>
            </template>
            <span> {{ title }} </span>
        </v-col>
        <v-col cols="auto" v-if="$slots['subtitle']"> <slot name="subtitle" /> </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" v-if="showsFilterButton || $scopedSlots['buttons']">
            <slot name="buttons" />
            <v-btn v-if="showsFilterButton" color="secondary" rounded class="ml-3 my-n2" @click="$emit('input', !value)"><v-icon small>mdi-filter-variant</v-icon>검색필터</v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        value: { type: Boolean, default: false },

        title: { type: String, default: "목록" },
        showsPrevButton: { type: Boolean, default: false },
        showsFilterButton: { type: Boolean, default: false },
    },
};
</script>

<style></style>
